const CLOSE_BUTTON_STYLES = {
  sm: "flex justify-center text-center text-lg leading-none min-w-[20px] min-h-[20px] active:drop-shadow active:bg-secondary active:text-white text-secondary rounded-full hover:text-white hover:bg-red-500",
  md: "flex justify-center text-center text-2xl leading-none min-w-[30px] min-h-[30px] active:drop-shadow active:bg-secondary active:text-white text-secondary rounded-full hover:text-white hover:bg-red-500",
  lg: "flex justify-center text-center text-3xl leading-none min-w-[40px] min-h-[40px] active:drop-shadow active:bg-secondary active:text-white text-secondary rounded-full hover:text-white hover:bg-red-500",
};

const CloseButton = ({ onClose = () => {}, size = "md" }) => {
  return (
    <button onClick={onClose} className={CLOSE_BUTTON_STYLES[size]}>
      &times;
    </button>
  );
};

export default CloseButton;
